import { cn } from "@/lib/utils";

/**
 * Editorial / terminal-style page header.
 * KICKER  ·  SECTION  ·  live dot
 * <Title in serif italic gold> ............................. [actions]
 * $ subtitle
 */
export function PageHeader({ title, subtitle, actions, breadcrumbs, kicker }) {
    return (
        <div className="px-4 md:px-8 pt-6 pb-4 bg-background">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
                <div className="min-w-0">
                    <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.2em] font-mono mb-1.5">
                        {kicker && <span className="text-gold">{kicker}</span>}
                        {kicker && <span className="opacity-40">·</span>}
                        <span className="text-muted-foreground">{new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }).toUpperCase()}</span>
                        <span className="live-dot ml-1" />
                    </div>
                    {breadcrumbs && (
                        <div className="text-[11.5px] text-muted-foreground mb-1.5 font-mono">{breadcrumbs}</div>
                    )}
                    <h1 className="font-display text-[34px] md:text-[40px] leading-[1.04] tracking-tight font-light text-foreground">
                        {title}
                    </h1>
                    {subtitle && (
                        <p className="text-[12.5px] text-muted-foreground mt-2 font-mono max-w-3xl">
                            <span className="text-gold mr-1.5">$</span>{subtitle}
                        </p>
                    )}
                </div>
                {actions && <div className="flex flex-wrap items-center gap-2 shrink-0">{actions}</div>}
            </div>
        </div>
    );
}

export function PageBody({ className, children }) {
    return <div className={cn("px-4 md:px-8 py-4", className)}>{children}</div>;
}
